import { formatBigMoney, formatMoney, formatPercentage } from '../../../packages/utils/numberFormatters'
import { AxisPropOption } from '../ScatterPlot'

export const AXIS_OPTIONS_LABELS = {
    avgTurnover: { type: 'currency', label: 'Omsättning / dag i SEK, innan emissionen (10d)' },
    commitment: { type: 'percent', label: 'Teckningsåtagande ex. garanter (%)' },
    dilutionActual: { type: 'percent', label: 'Utspädning (faktisk)' },
    dilutionMax: { type: 'percent', label: 'Utspädning (max)' },
    feeCash: { type: 'percent', label: 'Garantiersättning kontant (%)' },
    feeUnits: { type: 'percent', label: 'Garantiersättning aktier/units (%)' },
    offerSize: { type: 'currency', label: 'Storlek på emission i SEK' },
    preMoney: { type: 'currency', label: 'Pre-money värdering' },
    priceChangeMax: { type: 'percent', label: 'Kursutveckling Max' },
    priceChange3m: { type: 'percent', label: 'Kursutveckling 3 mån' },
    priceChange6m: { type: 'percent', label: 'Kursutveckling 6 mån' },
    priceChange12m: { type: 'percent', label: 'Kursutveckling 12 mån' },
    subscribedSize: { type: 'currency', label: 'Tecknat belopp i SEK' },
    subscriptionQuota: { type: 'percent', label: 'Teckningsgrad (%)' },
    subscriptionQuotaExclGuarantors: { type: 'percent', label: 'Teckningsgrad ex. garanter (%)' },
    subscriptionQuotaExclGuarantorsAndCommitments: { type: 'percent', label: 'Andel tecknat utöver TÅ (%)' },
    totalCommitment: { type: 'percent', label: 'Säkerställandegrad (%)' },
    vwap10d: { type: 'percent', label: 'Rabatt mot 10 dagar VWAP (%)' },
    vwap10dTerp: { type: 'percent', label: 'TERP-rabatt mot 10 dagar VWAP (%)' },
} as const

export const formatValue = (
    item: Partial<Record<AxisPropOption, number | null>>,
    prop: AxisPropOption,
    { locale, short = true }: { locale: string; short?: boolean },
): string => {
    if (item[prop] === null || item[prop] === undefined) return ''
    if (AXIS_OPTIONS_LABELS[prop].type === 'percent') {
        return formatPercentage(item[prop], { decimals: short ? 0 : undefined, locale })
    }

    if (AXIS_OPTIONS_LABELS[prop].type === 'currency') {
        if (short) return formatBigMoney(item[prop], { locale })
        return formatMoney(item[prop], { locale })
    }

    return item[prop].toString()
}
